import { Button, PageContainer } from "@govlaunch/web";
import Link from "next/link";
import React, { useState } from "react";
import { useSelfie } from "~/components/auth/Auth";
import CreateProjectModal from "~/src/components/project/CreateProjectModal";
import AddProjectIcon from "~/src/components/project/icons/AddProjectIcon";
import MyGovernmentIcon from "~/src/components/project/icons/MyGovernmentIcon";
import MyProjectsIcon from "~/src/components/project/icons/MyProjectsIcon";
import useIsMobile from "~/lib/hooks/useIsMobile";
import canCreateProjects from "~/src/components/project/canCreateProjects";
import { FormattedMessage } from "react-intl";

export default function ProjectsPageHeader() {
  const viewer = useSelfie();
  const viewerIsVendorOrGovernmentUser = viewer?.__typename === "VendorUser" || viewer?.__typename === "GovernmentUser";
  const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState<boolean>(false);
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  return (
    <PageContainer my={3} minH="1px">
      {canCreateProjects(viewer) && (
        <Button leftIcon={AddProjectIcon} onClick={() => setIsAddProjectModalOpen(true)}>
          <FormattedMessage defaultMessage="Add Project" id="BAZtPp" />
        </Button>
      )}

      {viewerIsVendorOrGovernmentUser && (
        <Link
          href={`/user?userSlug=${viewer?.slug}&tab=projects`}
          as={`/@${viewer?.slug}/projects`}
          passHref={true}
          legacyBehavior={true}
        >
          <Button as="a" leftIcon={MyProjectsIcon}>
            <FormattedMessage defaultMessage="My Projects" id="FVO2wx" />
          </Button>
        </Link>
      )}

      {viewer?.__typename === "GovernmentUser" && (
        <Link
          href={`/government?governmentSlug=${viewer.government.slug}&content=projects`}
          as={`/governments/${viewer.government.slug}/projects`}
          passHref={true}
          legacyBehavior={true}
        >
          <Button as="a" leftIcon={MyGovernmentIcon}>
            <FormattedMessage defaultMessage="My Government" id="aAYh0/" />
          </Button>
        </Link>
      )}

      {viewerIsVendorOrGovernmentUser && (
        <CreateProjectModal isOpen={isAddProjectModalOpen} onClose={() => setIsAddProjectModalOpen(false)} />
      )}
    </PageContainer>
  );
}
